import React from 'react';
import {SearchResultItemType} from "../../search/sections/navigation-menu/@type";
import FieldViewProperty from "../../../core/fields3/render/view-property";
import FieldView from "../../../core/fields3/render/view";
import TaskMorePopoverMenu from "../../../core/gd-ui/more/task/more-popover-menu";
import ControlButtonStandard, {ControlButtonType} from "../../../core/gd-components/buttons/control-button/control-button-standard";
import {ControlButtonSize} from "../../../core/gd-components/buttons/control-button/@types";
import {findDOMNode} from "react-dom";
import Popover from "../../../core/gd-components/gd-popover/popover";
import {PopoverAttachmentType} from "../../../core/gd-components/gd-popover/@const";
import {FieldProject_ViewType} from "../../../core/fields3/generic/entity/project/render/view"

type Props = {
    menuItem: SearchResultItemType
}

type State = {
    showPopover: boolean
}

export default class MenuSearch_TaskResult extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            showPopover: false
        }
    }

    showPopover = (e: React.SyntheticEvent)=> {
        e.stopPropagation()
        this.setState({showPopover: true})
    }

    onClickOutside = ()=> {
        this.setState({showPopover: false})
    }

    onClick = ()=> {
        gd.taskView.open(this.props.menuItem.id, null);
    }

    render() {

        if(!this.props.menuItem.task) return null

        const fields = gd.fields.task

        const classes = Classes("search-result", {
            'hovered'         : this.state.showPopover
        })

        const moreButton = Classes("more", {
           'popover-shown'         : this.state.showPopover
        })

        return (
            <div className={classes} onClick={this.onClick} onContextMenu={this.showPopover}>
                <div className="row">
                    <div className="flex-row-center-between w-100-percent">
                        <div className="name">
                            {this.props.menuItem.task.title}
                        </div>
                        <ControlButtonStandard className    = {moreButton}
                                               type         = {ControlButtonType.MORE}
                                               size         = {ControlButtonSize.SIZE_24}
                                               onClick      = {this.showPopover}>
                            {this.state.showPopover && (
                                <Popover popoverClass       = "gd-view-more-popover"
                                         attachment         = "top left"
                                         targetAttachment   = "top right"
                                         offset             = "3 0"
                                         attachmentType     = {PopoverAttachmentType.VERTICAL}
                                         getTargetFunc      = {()=>findDOMNode(this)}
                                         onClickOutside     = {this.onClickOutside}>

                                    <TaskMorePopoverMenu task           = {this.props.menuItem.task}
                                                         showOpen       = {true}
                                                         hidePopover    = {this.onClickOutside}/>

                                </Popover>
                            )}

                        </ControlButtonStandard>
                    </div>

                </div>
                <div className="flex-row-left-center w-100-percent p-r-5">
                    <FieldViewProperty className    = "flex-shrink-1 m-b-5 m-r-5"
                                       field        = {fields.projectId}
                                       params       = {{
                                           viewType: FieldProject_ViewType.FULL_PATH,
                                       }}
                                       model        = {this.props.menuItem.task}/>

                    <FieldView className    = "flex-no-shrink m-b-5 m-r-0"
                               field        = {fields.shortId}
                               model        = {this.props.menuItem.task}/>
                </div>

            </div>
        )
   }
}
